module.exports = __webpack_public_path__ + "img/product1-2.c34a3594.png";